import React from "react";
import PagebuilderHelper from "../../PagebuilderHelper";

function PreviewLessonGrid(props) {
  const element = props.element;

  return (
    <div
      className={`pagebuilder-element-preview pagebuilder-element-preview-text`}
    >
      {PagebuilderHelper.getPreview(element)}
    </div>
  );
}

export default PreviewLessonGrid;
